$(function () {
    if ($('#gift-card-delivery').length) {
        new Vue({
            store: store,
            el: '#gift-card-delivery',
            data: {
                orderUuid: null,
                generatedGiftCards: [],
                giftCards: [],
                showModal: false,
                slide: 'select-codes',
                message: '',
                sending: false
            },
            computed: {
                validGiftCards: function () {
                    return this.giftCards && this.giftCards.length
                        ? this.giftCards.filter(function (o) { return o.canSend; }).sort(function (a, b) {
                                if (!a.sentDate && b.sentDate) {
                                    return -1;
                                }
                                if (a.sentDate && !b.sentDate) {
                                    return 1;
                                }
                                if (a.sentDate && b.sentDate) {
                                    if (Date.parse(a.sentDate) < Date.parse(b.sentDate)) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                                return 0;
                            })
                        : [];
                },
                selectedGiftCards: function () {
                    return this.validGiftCards.length ? this.validGiftCards.filter(function (o) { return o.selected }) : [];
                },
                validSelectedGiftCards: function () {
                    var vm = this;
                    return vm.validGiftCards.filter(function (o) { return vm.validateEmail(o.recipient); });
                }
            },
            methods: {
                validateEmail: function (email) {
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                },
                formatPrice: function (price) {
                    if (price) {
                        var formatter = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        });

                        return formatter.format(price);
                    }
                    return '--';
                },
                formatDate: function (date) {
                    if (!date) return '--';
                    var _date = new Date(date);
                    return _date.toLocaleDateString("en-US")
                },
                initializeGiftCards: function (giftCards) {
                    var vm = this;
                    if (giftCards && giftCards.length) {
                        vm.giftCards = giftCards.map(function (giftCard) {
                            return {
                                id: giftCard.id,
                                uuid: giftCard.uuid,
                                code: giftCard.code,
                                amount: giftCard.originalAmount,
                                selected: giftCard.selected,
                                originalRecipient: giftCard.recipient,
                                sentDate: giftCard.recipientSentDate,
                                canSend: giftCard.originalAmount == giftCard.remainingAmount && giftCard.remainingAmount > 0,
                                recipient: ''
                            }
                        });
                    }
                    else {
                        vm.giftCards = [];
                    }
                },
                sendGiftCards: function () {
                    var vm = this;
                    vm.error = null;
                    //vm.sending = true;
                    axios.post('/api/gift-cards/send', {
                        orderUuid: vm.orderUuid,
                        message: vm.message,
                        giftCards: vm.selectedGiftCards.filter(function (o) {
                            return o.recipient;
                        })
                    }).then(function (r) {
                        vm.getGiftCards()
                            .then(function (r2) {
                                if (r2 && r2.data) {
                                    vm.generatedGiftCards = r2.data;
                                    vm.initializeGiftCards(r2.data);
                                    vm.slide = 'confirmation';
                                    //vm.sending = false;
                                }
                            });
                    }).catch(
                        function (error) {
                            console.log('Error', error.message);
                            vm.sending = false;
                        }
                    );
                },
                getGiftCards: function () {
                    var route = '/api/gift-cards';
                    if (this.orderUuid) {
                        route += '/order?orderUuid=' + this.orderUuid;
                    }
                    return axios.get(route);
                }
            },
            mounted: function () {
                var vm = this,
                    data = JSON.parse($('#giftCardsJson').text());

                this.orderUuid = data.orderUuid;
                this.generatedGiftCards = data.giftCards;
                this.initializeGiftCards(data.giftCards);
            }
        });
    }
});